import * as Primitive from '@radix-ui/react-tabs'
import type { ComponentProps } from 'react'
import { cn } from '../lib/cn'

export function Tabs({ className, ...props }: ComponentProps<typeof Primitive.Root>) {
  return <Primitive.Root {...props} data-slot="tabs" className={cn('min-w-0', className)} />
}

export function TabsList({ className, ...props }: ComponentProps<typeof Primitive.List>) {
  return (
    <Primitive.List
      {...props}
      data-slot="tabs-list"
      className={cn(
        'flex w-full max-w-full flex-nowrap items-center justify-center-safe gap-2 overflow-x-auto rounded-2xl border border-border bg-card p-2',
        className,
      )}
    />
  )
}

export function TabsTrigger({ className, ...props }: ComponentProps<typeof Primitive.Trigger>) {
  return (
    <Primitive.Trigger
      {...props}
      data-slot="tabs-trigger"
      className={cn(
        'relative min-h-11 shrink-0 whitespace-nowrap rounded-xl bg-card px-3 py-2 text-[13px] font-semibold text-foreground/70 transition-[color,background-color] before:absolute before:-left-1 before:top-3 before:bottom-3 before:w-px before:bg-border after:absolute after:inset-x-3 after:bottom-0 after:h-0.5 after:origin-center after:scale-x-0 after:rounded-full after:bg-primary after:transition-transform first:before:hidden hover:bg-primary/5 hover:text-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring disabled:pointer-events-none disabled:opacity-50 data-[state=active]:text-primary data-[state=active]:after:scale-x-100 motion-reduce:transition-none motion-reduce:after:transition-none sm:px-6 sm:text-sm',
        className,
      )}
    />
  )
}

export function TabsPanel({ className, ...props }: ComponentProps<typeof Primitive.Content>) {
  return (
    <Primitive.Content
      {...props}
      data-slot="tabs-panel"
      className={cn(
        'min-w-0 pt-5 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring',
        className,
      )}
    />
  )
}
